import { render, staticRenderFns } from "./ShowNotesDialog.vue?vue&type=template&id=3edb4f98&scoped=true"
import script from "./ShowNotesDialog.vue?vue&type=script&lang=js"
export * from "./ShowNotesDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowNotesDialog.vue?vue&type=style&index=0&id=3edb4f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb4f98",
  null
  
)

export default component.exports